/* 🧭 LinePieces (web) — the byline's icons: small, monochrome, in the text's colour.
   services/postCompose (shared with the phone) turns "is 📺 watching the final at
   📍 Riyadh" into pieces — text and neutral icon keys; the phone maps the keys to
   Ionicons, this maps them to the app's own inline SVG set (ui/icons). */
import React from 'react';
import { Sparkles, Tv, Utensils, Cup, Plane, Headphones, Search, Book, Gamepad, Megaphone, MapPin } from './icons';

export const LINE_ICON = {
  party: Sparkles, tv: Tv, food: Utensils, drink: Cup, plane: Plane, headphones: Headphones,
  search: Search, book: Book, game: Gamepad, support: Megaphone, pin: MapPin,
};

export function LineGlyph({ icon, size = 14 }) {
  const I = LINE_ICON[icon];
  if (!I) return null;
  return <I width={size} height={size} className="line-glyph" style={{ verticalAlign: '-0.15em', display: 'inline-block' }} aria-hidden="true" />;
}

export default function LinePieces({ pieces, size = 14 }) {
  return (
    <>
      {(pieces || []).map((p, i) => (p.icon
        ? <LineGlyph key={i} icon={p.icon} size={size} />
        : <React.Fragment key={i}>{p.text}</React.Fragment>))}
    </>
  );
}
